import * as _ from "lodash-es";
import axios from "axios";
import { notifyAxiosError } from "@/notify";
import { makeOptions } from "@/form-utils";
import { EMAIL_TEMPLATE_KINDS, MAX_PAGE_SIZE } from "@/constants";

export default {
  namespaced: true,
  state: {
    automatedTemplatesMap: {},
    isAutomatedTemplatesFetching: false,
    isAutomatedTemplatesFetched: false,
  },
  mutations: {
    setAutomatedTemplates: function (state, automatedTemplates) {
      state.automatedTemplatesMap = _.keyBy(automatedTemplates, "id");
    },
    setAutomatedTemplatesFetching: function (state, isAutomatedTemplatesFetching) {
      state.isAutomatedTemplatesFetching = isAutomatedTemplatesFetching;
    },
    setAutomatedTemplatesFetched: function (state, isAutomatedTemplatesFetched) {
      state.isAutomatedTemplatesFetched = isAutomatedTemplatesFetched;
    },
    updateCustomTemplate: function (state, template) {
      if (template.kind !== EMAIL_TEMPLATE_KINDS.CUSTOM) {
        return;
      }
      state.automatedTemplatesMap = {
        ...state.automatedTemplatesMap,
        [template.id]: template,
      };
    },
  },
  getters: {
    automatedTemplatesOptions(state) {
      return makeOptions(
        Object.values(state.automatedTemplatesMap)
          // Can't use backend ordering here because when template is created
          // we should place it somewhere without extra api request.
          .sort((a, b) => {
            if (a.name > b.name) {
              return 1;
            } else if (a.name < b.name) {
              return -1;
            }
            return 0;
          })
          .map((t) => ({ value: t.id, text: t.name })),
      );
    },
  },
  actions: {
    fetchAutomatedTemplates(context) {
      if (
        context.state.isAutomatedTemplatesFetching ||
        context.state.isAutomatedTemplatesFetched
      ) {
        return;
      }
      context.commit("setAutomatedTemplatesFetching", true);
      axios
        .get("/email-templates/", {
          params: {
            page_size: MAX_PAGE_SIZE,
            kinds: [
              EMAIL_TEMPLATE_KINDS.CUSTOM,
              EMAIL_TEMPLATE_KINDS.MARKETING,
              EMAIL_TEMPLATE_KINDS.ENROLMENT_OFFER_ACCEPTED_STAFF,
              EMAIL_TEMPLATE_KINDS.RESERVED_PLACE_OFFER_ACCEPTED_STAFF,
            ],
          },
        })
        .then(
          (response) => {
            context.commit("setAutomatedTemplatesFetching", false);
            context.commit("setAutomatedTemplatesFetched", true);
            context.commit("setAutomatedTemplates", response.data.results);
          },
          (error) => {
            context.commit("setAutomatedTemplatesFetching", false);
            notifyAxiosError(error);
          },
        );
    },
  },
};
